module.exports = __webpack_public_path__ + "static/media/img111_R.30dc511b.jpg";